/**
 * Front-end JavaScript for the YouTube Video Background block.
 *
 * This script handles any necessary frontend functionality for the block.
 */

document.addEventListener("DOMContentLoaded", function () {
	// Function to handle video sizing
	function resizeVideoBackground() {
		const containers = document.querySelectorAll(".video-bg-iframe-container");

		containers.forEach((container) => {
			const iframe = container.querySelector("iframe");
			if (!iframe) return;

			// Ensure the iframe always covers the container
			const containerWidth = container.offsetWidth;
			const containerHeight = container.offsetHeight;
			const aspectRatio = 16 / 9;

			let width = containerWidth;
			let height = containerWidth / aspectRatio;

			if (height < containerHeight) {
				height = containerHeight;
				width = containerHeight * aspectRatio;
			}

			iframe.style.width = width + "px";
			iframe.style.height = height + "px";
		});
	}

	// Load YouTube API
	var tag = document.createElement("script");
	tag.src = "https://www.youtube.com/iframe_api";
	var firstScriptTag = document.getElementsByTagName("script")[0];
	firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

	// When YouTube API is ready
	window.onYouTubeIframeAPIReady = function () {
		// Find all YouTube iframes
		document
			.querySelectorAll(".video-bg-iframe-container iframe")
			.forEach(function (iframe) {
				if (!iframe.id) {
					iframe.id = "youtube-bg-" + Math.random().toString(36).substr(2, 9);
				}

				// Create player for each iframe
				new YT.Player(iframe.id, {
					events: {
						onReady: function (event) {
							// Make sure video is playing
							event.target.playVideo();
						},
						onStateChange: function (event) {
							// If video ends, restart it
							if (event.data === YT.PlayerState.ENDED) {
								event.target.playVideo();
							}
						},
					},
				});
			});
	};

	// Initial resize
	resizeVideoBackground();

	// Resize on window resize
	window.addEventListener("resize", resizeVideoBackground);
});
